/* ============================================================
   KACHING BUNDLE MERGE — BRAVION / PestBlock Pods
   Thème : Lumin (base Dawn) — panier natif
   ------------------------------------------------------------
   Quand le client ajoute un bundle alors qu'il en a déjà un,
   les deux sont fusionnés en un seul palier :
     1 + 1 payant  -> Buy 2 Get 1
     1 + 2 payants -> Buy 3 Get 2

   v4 — la détection se fait sur le PANIER après l'add, jamais
   sur le contenu de la requête (dont le format est inconnu).
   C'est la logique de la v2, qui fonctionnait, avec les
   suppressions optimisées : ~4 appels réseau au lieu de 13.

   Ne touche pas à /cart/change.js, donc ne peut pas déclencher
   le message "You can only add X of this item to your cart".

   INSTALLATION
   Assets > kaching-bundle-merge.js  (remplacer le contenu)
   theme.liquid, avant </body> :
   <script src="{{ 'kaching-bundle-merge.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  'use strict';

  // ====================== CONFIG ======================

  const PRODUCT_ID = 8824266621126;
  const VARIANT_ID = 45636889936070;
  const DEAL = 'ircp';
  const V = 'da1aac6c-1810-478c-bd21-d965fc510453';

  const TIERS = [
    { label: 'Buy 1',       barName: 'bid', barKey: 'ce6bbc8e-0ac3-47f5-8fa8-e1de0a7a5b5e', paid: 1, free: 0 },
    { label: 'Buy 2 Get 1', barName: 'bar', barKey: '37a06454-f184-4229-a82c-cd9b1502191e', paid: 2, free: 1 },
    { label: 'Buy 3 Get 2', barName: 'bar', barKey: '2c1b88c9-0ee7-45e8-9432-c89e0c82c47c', paid: 3, free: 2 },
  ];

  // Somme sans palier correspondant (ex : 1 + 3 = 4 payants) :
  // false = on ne touche à rien. true = on rabat sur le plus gros
  // palier, ce qui fait perdre des unités payées au client.
  const CAP_TO_MAX = false;

  const FALLBACK_SECTIONS = 'cart-drawer,cart-icon-bubble';

  // Mets à true et regarde la console pour diagnostiquer.
  const DEBUG = false;

  // ====================================================

  const log = (...a) => DEBUG && console.log('[kaching-merge]', ...a);
  const nativeFetch = window.fetch.bind(window);

  const getCart = () =>
    nativeFetch('/cart.js', { headers: { 'Content-Type': 'application/json' } }).then((r) => r.json());

  function groupId() {
    const c = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let o = '';
    for (let i = 0; i < 4; i++) o += c[Math.floor(Math.random() * c.length)];
    return o;
  }

  function readProps(item) {
    const raw = item && item.properties && item.properties.__kaching_bundles;
    if (!raw) return null;
    try {
      return typeof raw === 'string' ? JSON.parse(raw) : raw;
    } catch (e) {
      return null;
    }
  }

  const tierOf = (p) => (p ? TIERS.findIndex((t) => t.barKey === (p.bar || p.bid)) : -1);

  // Tout se déduit du panier : nombre de groupes, unités payées,
  // clés à supprimer, plan d'abonnement.
  function analyse(cart) {
    const groups = new Set();
    const keys = [];
    let paid = 0;
    let plan = null;
    let foreign = 0; // lignes hors bundle

    cart.items.forEach((item) => {
      const p = readProps(item);
      const t = tierOf(p);
      const belongs = p && p.deal === DEAL && (t !== -1 || !!p.gift);

      if (!belongs) {
        foreign++;
        return;
      }

      keys.push({ key: item.key, child: !!item.parent_relationship });

      if (t !== -1 && !p.bxgy) {
        groups.add(p.id);
        paid += TIERS[t].paid;
      }

      if (!plan && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        plan = item.selling_plan_allocation.selling_plan.id;
      }
    });

    // enfants d'abord : la Shipping Protection part avant son parent
    keys.sort((a, b) => (b.child ? 1 : 0) - (a.child ? 1 : 0));

    return {
      count: groups.size,
      keys: keys.map((k) => k.key),
      paid,
      plan,
      onlyBundle: foreign === 0,
    };
  }

  function buildItems(tier, plan) {
    const gid = groupId();
    const sp = plan ? { selling_plan: plan } : {};
    const items = [];

    const paid = { deal: DEAL, pp: PRODUCT_ID, main: true, v: V, id: gid };
    paid[tier.barName] = tier.barKey;
    items.push({
      id: VARIANT_ID,
      quantity: tier.paid,
      properties: { __kaching_bundles: JSON.stringify(paid) },
      ...sp,
    });

    if (tier.free > 0) {
      const free = { id: gid, deal: DEAL };
      free[tier.barName] = tier.barKey;
      free.v = V;
      free.main = true;
      free.bxgy = true;
      items.push({
        id: VARIANT_ID,
        quantity: tier.free,
        properties: { __kaching_bundles: JSON.stringify(free) },
        ...sp,
      });
    }

    return items;
  }

  function sectionsFrom(body) {
    try {
      if (typeof body === 'string') {
        const o = body.trim().startsWith('{')
          ? JSON.parse(body)
          : Object.fromEntries(new URLSearchParams(body).entries());
        return o.sections || null;
      }
      if (body instanceof FormData || body instanceof URLSearchParams) {
        return body.get('sections') || null;
      }
      if (body && typeof body === 'object' && body.sections) return body.sections;
    } catch (e) {
      /* noop */
    }
    return null;
  }

  // ==================== interception ====================

  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const opts = init || {};

    if (!/\/cart\/add(\.js)?(\?|$)/.test(url)) return nativeFetch(input, init);

    // 1. On laisse l'add se faire normalement (tracking, état Kaching, etc.)
    const res = await nativeFetch(input, init);
    if (!res.ok) return res;

    // 2. On constate le résultat sur le panier
    let cart;
    try {
      cart = await getCart();
    } catch (e) {
      return res;
    }

    const state = analyse(cart);
    log('groupes', state.count, '| payants', state.paid, '| hors bundle', !state.onlyBundle);

    if (state.count < 2) return res; // un seul groupe : rien à fusionner

    let target = TIERS.findIndex((t) => t.paid === state.paid);
    if (target === -1) {
      if (!CAP_TO_MAX) {
        log('total', state.paid, 'sans palier correspondant, on ne touche à rien');
        return res;
      }
      target = TIERS.length - 1;
    }

    log('fusion ->', TIERS[target].label);

    // 3. Nettoyage. Un seul appel si le panier ne contient que le bundle.
    if (state.onlyBundle) {
      await nativeFetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      }).catch((e) => log('clear', e));
    } else {
      for (const key of state.keys) {
        await nativeFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
        }).catch((e) => log('remove', e));
      }
    }

    // 4. Un seul add, qui renvoie directement les sections à re-rendre
    const sections = sectionsFrom(opts.body) || FALLBACK_SECTIONS;

    return nativeFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: buildItems(TIERS[target], state.plan),
        sections: sections,
        sections_url: window.location.pathname,
      }),
    });
  };

  log('actif');
})();